import { inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { COMPANY_CONFIG_RAW, flooriRoutes } from '@floori-web/constants';

export const configGuard = (): boolean | UrlTree =>
    !!inject(COMPANY_CONFIG_RAW) ? true : inject(Router).createUrlTree([flooriRoutes.notFound]);
